import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Badge } from 'reactstrap';
import _ from 'lodash';

import { Icon } from '@breezeway/brzw-components';
import { TASK_PRIORITY_OPTIONS } from '@common/utils/task';

import './priority-badge.scss';

const STATUS = {
  NORMAL: 'normal',
  MEDIUM: 'medium',
};

const CLASS_NAME = 'priority-badge';

const getBadgeColor = status => {
  switch (status) {
    case 'urgent':
      return 'warning';
    case 'high':
      return 'danger';
    default:
      return null;
  }
};

const PriorityBadge = ({ className, status, withIcon, withName }) => {
  const statusCode = _.get(status, 'code');
  const currentStatus = _.first(
    _.filter(TASK_PRIORITY_OPTIONS, option => option.code === statusCode),
  );
  const statusName = _.get(currentStatus, 'name', '');
  const iconName = statusCode === STATUS.NORMAL ? STATUS.MEDIUM : statusCode;

  const renderStatus = () => (
    <>
      {withIcon && <Icon iconName={iconName} />}
      {withName && statusName}
    </>
  );

  if (status) {
    return (
      <Badge
        className={classnames(`${CLASS_NAME}`, {
          [className]: className,
        })}
        color={getBadgeColor(statusCode)}
      >
        {renderStatus()}
      </Badge>
    );
  }

  return null;
};

PriorityBadge.propTypes = {
  className: PropTypes.string,
  status: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
  }),
  withIcon: PropTypes.bool,
  withName: PropTypes.bool,
};

export default PriorityBadge;
